import { render } from "./aCopyNew.vue?vue&type=template&id=0fb15844&ts=true"
import script from "./aCopyNew.vue?vue&type=script&lang=ts"
export * from "./aCopyNew.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__